import { render, staticRenderFns } from "./ModalEditBox.vue?vue&type=template&id=4744a06c&scoped=true&"
import script from "./ModalEditBox.vue?vue&type=script&lang=js&"
export * from "./ModalEditBox.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditBox.vue?vue&type=style&index=0&id=4744a06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4744a06c",
  null
  
)

export default component.exports